import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { isNull } from 'lodash/fp';

import { SavedElementTypes } from 'constants/savedElements';
import FormattedDate from 'components/shared/FormattedDate';
import { Icon, Button } from 'ui';
import Table from 'components/shared/table';

const ElementRow = ({
  id,
  displayType,
  savedElementType,
  title,
  lastUpdatedAt,
  createdAt,
  sectionsUsed,
}) => {
  const modifiedField = lastUpdatedAt || createdAt;
  const dayAgo = moment().subtract(1, 'day');
  const isLinked = savedElementType === SavedElementTypes.Linked;

  return (
    <Table.Row>
      <Table.BodyCell split size="xl">
        <>
          <span className="text-wrap">
            <Link to={`/content/library/elements/${id}`}>{title}</Link>
            {isLinked && <Icon name="link" className="ml-8" />}
          </span>
          {isLinked && (
            <Link to={`/content/library/elements/${id}/edit`}>
              <Button icon="edit" />
            </Link>
          )}
        </>
      </Table.BodyCell>
      <Table.BodyCell size="l">
        <span>{displayType}</span>
      </Table.BodyCell>
      <Table.BodyCell size="s">
        <span>
          {moment(modifiedField.date) <= dayAgo ? (
            <FormattedDate>{modifiedField.date}</FormattedDate>
          ) : (
            moment(modifiedField.date).fromNow()
          )}
        </span>
        <div className="c-midnight-70">
          {lastUpdatedAt ? t('common.updated_by') : t('common.created_by')}{' '}
          {modifiedField.user.name}
        </div>
      </Table.BodyCell>
      <Table.BodyCell size="s">
        <span className="ta-c">
          {isNull(sectionsUsed) ? '-' : sectionsUsed}
        </span>
      </Table.BodyCell>
    </Table.Row>
  );
};

export default ElementRow;
